import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';
import { config } from '../config';

export const ProductContext = createContext();

export const ProductProvider = ({ children }) => {
  const apiUrl = config.apiUrl;
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [banners, setBanners] = useState([]);
  const [pixel, setPixel] = useState([]);
  const [footerMenus, setFooterMenus] = useState([]);
  const [contactInfo, setContactInfo] = useState({});
  const [logo, setLogo] = useState({});
  const [socialLinks, setSocialLinks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filteredProducts, setFilteredProducts] = useState([]);

  const [testEventCode, setTestEventCode] = useState([])
  const [isPurchase, setIsPurchase] = useState(false)

  // Single API call — homepage-data already returns pixels, no second /pixels call needed
  const fetchAllData = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await axios.get(`${apiUrl}/homepage-data`);

      if (response.data.success) {
        const data = response.data.data;

        setProducts(data.products || []);
        setCategories(data.categories || []);
        setBanners(data.banners || []);
        setFooterMenus(data.footer_menus || []);
        setContactInfo(data.contact_info || {});
        setLogo(data.logo || {});
        setSocialLinks(data.social_links || []);

        // pixels come from homepage-data — no second network round-trip
        const pixelList = data.pixels || [];
        setPixel(pixelList.map((p) => p.pixel_id));
        setTestEventCode(pixelList.map((p) => p.test_event_code));
        setIsPurchase(pixelList.length > 0 ? (pixelList[0].is_purchase ?? false) : false);
      } else {
        throw new Error(response.data.message || 'Failed to fetch data');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllData();
  }, [apiUrl]);

  const filterProductsByCategory = (categoryId) => {
    const filtered = products.filter(
      (product) => product.category_id === categoryId
    );
    setFilteredProducts(filtered);
  };



  return (
    <ProductContext.Provider
      value={{
        // Existing data
        products,
        filteredProducts,
        categories,
        pixel,
        testEventCode,
        isPurchase,
        banners,
        loading,
        setLoading,
        error,
        
        // New data from consolidated API
        footerMenus,
        contactInfo,
        logo,
        socialLinks,
        filterProductsByCategory,
        
        // Methods
        refetchData: fetchAllData,
        apiUrl
      }}
    >
      {children}
    </ProductContext.Provider>
  );
};
